import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { supabase } from "@/integrations/supabase/client";
import { useEffect, useState } from "react";
import { FileText, Download } from "lucide-react";

const AttestationDroitImage = () => {
  const [adulteUrl, setAdulteUrl] = useState<string>("");
  const [mineurUrl, setMineurUrl] = useState<string>("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPdfUrls = async () => {
      try {
        // Get public URLs for the PDFs
        const { data: adulteData } = supabase.storage
          .from('DroitImage')
          .getPublicUrl('AttestationADULTE.pdf');
        
        const { data: mineurData } = supabase.storage
          .from('DroitImage')
          .getPublicUrl('AttestationMINEUR.pdf');

        setAdulteUrl(adulteData.publicUrl);
        setMineurUrl(mineurData.publicUrl);
      } catch (error) {
        console.error("Error fetching PDF URLs:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPdfUrls();
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow relative overflow-hidden">
        {/* Background with gradient and gavroche */}
        <div className="absolute inset-0 z-0">
          <div className="h-full w-full bg-gradient-to-br from-[#FFFF4D] via-[#FFE94B] to-[#A3D960]"></div>
          <div className="absolute top-0 right-0 h-full w-1/3 md:w-2/5 opacity-30 md:opacity-40 flex items-end">
            <img 
              src="/lovable-uploads/180f51c0-05cf-4dfd-b4b7-91b153baf486.png" 
              alt="Décoration" 
              className="h-auto w-full object-contain object-bottom drop-shadow-xl" 
            />
          </div>
        </div>
        
        <div className="container relative z-10 mx-auto px-4 py-16 pt-32">
          <Card className="max-w-3xl mx-auto bg-white/90 backdrop-blur-sm">
            <CardHeader>
              <CardTitle className="text-3xl font-bold text-center text-[#001233]">
                Attestations de droit à l'image
              </CardTitle>
            </CardHeader>
            <CardContent className="pb-12 px-6">
              <p className="text-center mb-8 text-muted-foreground">
                Téléchargez l'attestation correspondante selon l'âge du participant
              </p>
              
              <div className="flex flex-col gap-6 max-w-md mx-auto">
                <div className="p-6 border rounded-lg bg-white shadow-sm">
                  <div className="flex items-center gap-3 mb-4">
                    <FileText className="h-8 w-8 text-[#4AA9E6]" />
                    <div>
                      <h3 className="font-semibold text-lg">Attestation Adulte</h3>
                      <p className="text-sm text-muted-foreground">Pour les participants majeurs</p>
                    </div>
                  </div>
                  <Button 
                    className="w-full bg-[#4AA9E6] hover:bg-[#3A99D6] text-white"
                    asChild
                    disabled={loading || !adulteUrl}
                  >
                    <a href={adulteUrl} target="_blank" rel="noopener noreferrer" download>
                      <Download className="h-4 w-4 mr-2" />
                      Télécharger l'attestation adulte
                    </a>
                  </Button>
                </div>

                <div className="p-6 border rounded-lg bg-white shadow-sm">
                  <div className="flex items-center gap-3 mb-4">
                    <FileText className="h-8 w-8 text-[#4AA9E6]" />
                    <div>
                      <h3 className="font-semibold text-lg">Attestation Mineur</h3>
                      <p className="text-sm text-muted-foreground">Pour les participants mineurs</p>
                    </div>
                  </div>
                  <Button 
                    className="w-full bg-[#4AA9E6] hover:bg-[#3A99D6] text-white"
                    asChild
                    disabled={loading || !mineurUrl}
                  >
                    <a href={mineurUrl} target="_blank" rel="noopener noreferrer" download>
                      <Download className="h-4 w-4 mr-2" />
                      Télécharger l'attestation mineur
                    </a>
                  </Button>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default AttestationDroitImage;
